module.exports = __webpack_public_path__ + "img/instagram.4aeac383.svg";